// Pure checks deciding which tokens the "View as user" swap may save, restore or accept (spec B4).
// These are client-side sanity bindings; the API still authorises every request.
import { ROLE_SUPER_ADMIN } from '../enums/roles'
import { claimsFromToken, impersonationInfo } from './impersonation'

const roleName = (role) => (typeof role === 'string' ? role : role?.name)

const isSuperAdminClaims = (claims) => !!claims && !impersonationInfo(claims) &&
  (claims.roles || []).map(roleName).includes(ROLE_SUPER_ADMIN)

const isUser = (claims, uuid) => !!uuid && (claims.sub === uuid || claims.uuid === uuid)

const notExpired = (claims, nowMs) => !claims.exp || claims.exp * 1000 > nowMs

export const isSuperAdminToken = (token) => isSuperAdminClaims(claimsFromToken(token))

// The impersonation token must have been minted for the super admin who is starting it.
export const canStartImpersonation = (adminToken, impersonationToken) => {
  const admin = claimsFromToken(adminToken)
  const imp = claimsFromToken(impersonationToken)
  return isSuperAdminClaims(admin) && !!impersonationInfo(imp) && isUser(admin, imp.impersonatorUuid)
}

// True only for the unexpired super-admin token saved when THIS impersonation session started.
export const isRestorable = ({ savedToken, savedSessionId, impersonationClaims }, nowMs = Date.now()) => {
  const info = impersonationInfo(impersonationClaims)
  const saved = claimsFromToken(savedToken)
  if (!info || !isSuperAdminClaims(saved) || savedSessionId !== info.impersonationId) return false
  return isUser(saved, impersonationClaims.impersonatorUuid) && notExpired(saved, nowMs)
}

// ?_token= only ever carries a login token; an impersonation token there is never trusted.
export const isTrustedUrlToken = (token) => !!token && !impersonationInfo(claimsFromToken(token))
